// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"05231946","133":"7b5598bb","568":"6afedb2f","917":"84802c23"}[chunkId] + ".chunk.css";
};